// @flow
import * as React from 'react';

import { selectIsCartIncludedBundleUseOnce } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

function BundleTypeWarning(): React.MixedElement | null {
  const { __ } = useTranslator();

  const bundleHasUseOnce = useAppSelector(selectIsCartIncludedBundleUseOnce);

  if (!bundleHasUseOnce) return null;

  return (
    <Base
      tagName="p"
      marginTop="none"
      marginBottom="base"
      padding="small"
      backgroundColor="surface"
    >
      {__(
        'The .fr/.best bundle in your shopping cart is limited to one ' +
          'purchase per organization. If you select an organization that has ' +
          'already benefited from this offer, the domains in the bundle will ' +
          'remain in your shopping cart but will be sold at their normal price.',
      )}
      <br />
      {__(
        'If you no longer wish to register any of those domains you can ' +
          'remove them from your shopping cart before payment.',
      )}
    </Base>
  );
}

export default (BundleTypeWarning: React.ComponentType<{}>);
